import React from 'react';

import { Box, Typography } from '@mui/material';

interface CampaignRunMetricProps {
  title: string;
  value: string;
  detail: string;
}

export default function CampaignRunMetric({ title, value, detail }: CampaignRunMetricProps) {
  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2 }}>
      <Typography variant="caption" color="text.secondary">
        {title}
      </Typography>
      <Typography variant="h6" sx={{ my: 0.5 }}>
        {value}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {detail}
      </Typography>
    </Box>
  );
}
